<template>
  <div
    v-if="count < 2"
    class="p-4 analytics-loading"
  >
    <b-spinner variant="primary" />
  </div>
  <vue-apex-charts
    v-else
    type="line"
    height="240"
    :options="options"
    :series="series"
  />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'NetworkChart',
  components: { VueApexCharts },
  props: {
    deviceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      id: null,
      count: 0,
    }
  },
  computed: {
    gettingHostNetwork() {
      return this.$store.state.observability.gettingHostNetwork
    },
    hostNetworkSend() {
      return this.$store.state.observability.hostNetworkSend
    },
    hostNetworkReceive() {
      return this.$store.state.observability.hostNetworkReceive
    },
    networkReceiveAnalytics() {
      return this.hostNetworkReceive
        ? this.hostNetworkReceive.map(val => this.getLineChartValue(val))
        : null
    },
    networkSendAnalytics() {
      return this.hostNetworkSend
        ? this.hostNetworkSend.map(val => this.getLineChartValue(val))
        : null
    },
    series() {
      return [
        {
          data: this.networkSendAnalytics
            ? this.networkSendAnalytics.map(el => el.count)
            : [],
          name: 'Send',
        },
        {
          data: this.networkReceiveAnalytics
            ? this.networkReceiveAnalytics.map(el => el.count)
            : [],
          name: 'Receive',
        },
      ]
    },
    options() {
      return {
        chart: {
          id: 'nc',
          zoom: { enabled: false },
          type: 'line',
          offsetX: -10,
          group: 'social',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        stroke: {
          curve: 'smooth',
          width: 4,
        },
        legend: {
          show: false,
        },
        colors: ['#DC2424', '#24C6DC'],
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            inverseColors: false,
            gradientToColors: ['#4A569D', '#514A9D'],
            shadeIntensity: 1,
            type: 'horizontal',
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100],
          },
        },
        markers: {
          size: 0,
          hover: {
            size: 5,
          },
        },
        xaxis: {
          labels: {
            offsetY: 5,
            style: {
              fontSize: '0.857rem',
            },
            axisBorder: {
              show: false,
            },
            tickPlacement: 'on',
          },
          tickAmount: 5,
          categories: this.networkSendAnalytics?.map(el => el.name),
        },
        yaxis: {
          labels: {
            minWidth: 40,
            style: {
              fontSize: '0.857rem',
            },
            formatter: val => this.formatBytes(Number(val), 2),
          },
        },
        tooltip: {
          followCursor: false,
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
      }
    },
  },
  watch: {
    deviceId() {
      this.count = 0
      this.fetchAnalytics()
    },
  },
  created() {
    this.id = this.$route.params.id
    this.fetchAnalytics()
  },
  methods: {
    getLineChartValue(el) {
      return {
        name: this.findName(el.timestamp),
        count: el.value,
      }
    },
    findName(name) {
      const d = new Date(name)
      return `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
    },

    fetchAnalytics() {
      if (this.deviceId !== '') {
        this.$store
          .dispatch('observability/getHostNetwork', {
            id: this.id,
            type: 'send',
            deviceId: this.deviceId,
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.count++
          })
        this.$store
          .dispatch('observability/getHostNetwork', {
            id: this.id,
            type: 'receive',
            deviceId: this.deviceId,
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.count++
          })
      } else {
        this.$store.commit('observability/GET_HOST_NETWORK_RECEIVE', [])
        this.$store.commit('observability/GET_HOST_NETWORK_SEND', [])
        this.count = 2
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.analytics-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 240px;
}
</style>
